<script>
import {mapGetters} from 'vuex';
import DeclarationItem from '../components/DeclarationItem.vue';
import NoContractor from '../assets/NoContractor.vue';
import Contractor from '../assets/Contractor.vue';

export default {
   name: 'ContractorsDeclarations',
   components: {Contractor, NoContractor, DeclarationItem},
   data() {
      return {
         stateSelection: null,
      };
   },
   computed: {
      ...mapGetters({
         isSME: 'isSME',
         studyPeriodMap: 'companies/studyPeriodMap',
         supportedPeriodIds: 'contractors/supportedPeriodIds',
         completed: 'contractors/isCompleted',
         declaration: 'contractors/declaration',
         importedVendors: 'contractors/importedVendors',
         manualVendors: 'contractors/manualVendors',
      }),

      periodNames() {
         return this.supportedPeriodIds
            .map((id) => this.studyPeriodMap[id]?.label)
            .filter((label) => !!label);
      },

      prettyPeriodNames() {
         const formatter = new Intl.ListFormat('en', {
            style: 'long',
            type: 'disjunction',
         });
         return formatter.format(this.periodNames);
      },

      hasVendors() {
         return this.importedVendors.length > 0 || this.manualVendors.length > 0;
      },

      isDisabled() {
         return this.isSME || this.completed || this.hasVendors;
      },
   },
   methods: {
      async declareContractors(declaration) {
         await this.$store.dispatch('contractors/saveDeclaration', {
            companyId: this.$companyId,
            declaration,
         });
      },
   },
};
</script>

<template>
   <div>
      <h5 id="label-study-years" class="mb-3" style="color: black; font-size: 16px">
         Did any of your projects utilize contractors' services in the time period{{
            periodNames.length === 1 ? '' : 's'
         }}
         {{ prettyPeriodNames }}?
      </h5>
      <div class="declaration-container">
         <DeclarationItem
            :active="declaration === false"
            :disabled="isDisabled"
            @input-declared="declareContractors"
            expense-type="contractors"
         >
            <template v-slot:icon>
               <NoContractor />
            </template>
            <template v-slot:description>
               <b>No</b>, all R&D work was done by in-house staff.
            </template>
         </DeclarationItem>
         <DeclarationItem
            :active="declaration === true"
            :disabled="isDisabled"
            :value="true"
            @input-declared="declareContractors"
            expense-type="contractors"
         >
            <template v-slot:icon>
               <Contractor />
            </template>
            <template v-slot:description>
               <b>Yes, we contracted</b> some work in support of our R&D efforts.
            </template>
         </DeclarationItem>
      </div>
   </div>
</template>

<style scoped lang="scss">
.declaration-container {
   display: flex;
   flex-wrap: wrap;
   gap: 1rem;
   margin-bottom: 2rem;
}
</style>
